import script from "./SingleCellPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleCellPage.vue?vue&type=script&setup=true&lang=js"

import "./SingleCellPage.vue?vue&type=style&index=0&id=bc76a52a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc76a52a"]])

export default __exports__